import React from "react";
import SelectTag from "./SelectTag";
import { useSelectTagContext } from "../../context/SelectTagContext";

function ByFactorFilter({ factorsData }) {
  const { selectedFilters } = useSelectTagContext();

  const SelectTagData = {
    factorsName: factorsData
      ? [...new Set(factorsData?.map((obj) => obj.name))].sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" })
        )
      : [],
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <SelectTag
          label="Factor"
          options={SelectTagData.factorsName}
          fieldName={"factorsName"}
          value={selectedFilters ? selectedFilters.factorsName : ""}
        />
      </div>
    </div>
  );
}

export default ByFactorFilter;
